import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { validateAuthToken } from "@/guards/validateAuthToken";

import { SectionRoute } from "@/components/shared/SectionRoute";
import { HeadingOne } from "@/components/ui/typography/HeadingOne";
import { MainSection } from "@/components/home/MainSection";
import { useAppSelector } from "@/app/store";
import { SkeletonHome } from "@/components/shared/skeletons/SkeletonHome";
import { validateActiveUser } from "@/guards/validateActiveUser";

export const Route = createFileRoute("/dashboard/")({
  beforeLoad: () => {
    validateAuthToken();
    validateActiveUser();
  },
  component: DashboardHomePage,
});

function DashboardHomePage() {
  const { data, status } = useAppSelector((state) => state.provider);
  const { t } = useTranslation();

  if (status === "failed") {
    return <Navigate to="/dashboard/error/generic-error" />;
  }

  if (status === "idle" || status === "loading") {
    return (
      <div className="mb-8 max-w-7xl mx-auto">
        <SectionRoute
          route_one={t("routes.dashboard")}
          route_two={t("routes.home")}
        />
        <SkeletonHome />
      </div>
    );
  }

  return (
    <>
      <div className="mb-8 max-w-7xl mx-auto">
        <SectionRoute
          route_one={t("routes.dashboard")}
          route_two={t("routes.home")}
        />
        <HeadingOne>
          {t("home.welcome_back")}, {data?.personalData?.firstname}!
        </HeadingOne>
        {/* <SectionCards /> */}
        <MainSection />
      </div>
    </>
  );
}
